import { render, staticRenderFns } from "./SVC00801.vue?vue&type=template&id=8dbf08d8&"
import script from "./SVC00801.vue?vue&type=script&lang=js&"
export * from "./SVC00801.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports